const OPTIONS = {
    openingCharacter: '{',
    closingCharacter: '}',
    separator: '.',
};
const REFERENCE_REGEX = /\{([^}]+)\}/g;

export { OPTIONS, REFERENCE_REGEX };
